import React, {
  useEffect,
  useState
} from "react";

import {
  useParams
} from "react-router-dom";

import logo from "../assets/logo.png";

const Quotation = () => {
  const { id } = useParams();

  const [products, setProducts] =
    useState([]);

  const [form, setForm] =
  useState({

    customer_name: "",
    phone: "",
    address: "",
    rent_date: "",

    labour_charge: 0,
    transport_charge: 0,

    products: []

  });

  // =====================================
  // FETCH PRODUCTS
  // =====================================

  useEffect(() => {

    fetch(
      "/api/products"
    )
      .then(res => res.json())
      .then(data =>
        setProducts(
          data.products || data
        )
      );

  }, []);
  useEffect(() => {

  if (!id) return;

  fetch(
    `/api/quotations/${id}`
  )
    .then(res => res.json())
    .then(data => {

      console.log(
        "QUOTATION DATA",
        data
      );

      if (!data.quotation) return;

      setForm({

        customer_name:
          data.quotation.customer_name || "",

        phone:
          data.quotation.phone || "",

        address:
          data.quotation.address || "",

        rent_date:
          data.quotation.rent_date
            ?.split("T")[0] || "",

        labour_charge:
          Number(
            data.quotation.labour_charge || 0
          ),

        transport_charge:
          Number(
            data.quotation.transport_charge || 0
          ),

        products:
          (data.items || []).map(
            item => ({

              product_id:
                item.product_id,

              quantity:
                item.quantity,

              rent:
                item.rent,

              days:
                item.days,

              name:
                item.product_name

            })
          )

      });

    })
    .catch(console.log);

}, [id]);

  // =====================================
  // ADD PRODUCT
  // =====================================

  const addProduct = () => {

    setForm({

      ...form,

      products: [

        ...form.products,

        {

          product_id: "",
          quantity: 1,
          rent: 0,
          days: 1,
          name: ""

        }

      ]

    });

  };

  // =====================================
  // PRODUCT CHANGE
  // =====================================

  const handleProductChange = (
    index,
    field,
    value
  ) => {

    const updated =
      [...form.products];

    if (
      field === "product_id"
    ) {

      const selected =
        products.find(
          p => p.id == value
        );

      if (selected) {

        updated[index].rent =
          Number(
            selected.rent_per_day
          ) || 0;

        updated[index].name =
          selected.name;

      }

    }

    updated[index][field] =
      value;

    setForm({

      ...form,
      products: updated

    });

  };

  // =====================================
  // TOTAL
  // =====================================

  const rentalTotal =
  form.products.reduce(

    (sum, item) => {

      return (

        sum +

        (

          Number(item.rent || 0)

          *

          Number(
            item.quantity || 0
          )

          *

          Number(
            item.days || 1
          )

        )

      );

    },

    0

  );

const totalAmount =

  rentalTotal

  +

  Number(
    form.labour_charge || 0
  )

  +

  Number(
    form.transport_charge || 0
  );

  const saveQuotation = async () => {

  const response = await fetch(

    "/api/quotations",

    {

      method: "POST",

      headers: {

        "Content-Type":
          "application/json"

      },

      body: JSON.stringify(form)

    }

  );

  return await response.json();

};
  // =====================================
  // PRINT
  // =====================================


const printQuotation = async () => {

  if (id) {

    window.print();

    return;

  }

  if (!form.customer_name.trim()) {

    alert("Customer name is required");

    return;

  }

  if (!form.phone.trim()) {

    alert("Phone number is required");

    return;

  }

  if (form.products.length === 0) {

    alert("Add at least one product");

    return;

  }

  const invalidProduct =
    form.products.some(
      item =>
        !item.product_id ||
        Number(item.quantity) <= 0 ||
        Number(item.days) <= 0
    );

  if (invalidProduct) {

    alert(
      "Please complete all product details"
    );

    return;

  }

  try {

    const result =
      await saveQuotation();

    if (result.success) {

      window.print();

    }

  } catch (err) {

    console.log(err);

  }

};
  return (

    <>

      <div className="min-h-screen bg-[#F5F7FB] p-6">

        {/* =====================================
            SCREEN VIEW
        ===================================== */}

        <div className="print:hidden">

          <div className="max-w-6xl mx-auto bg-white rounded-[32px] border border-gray-100 shadow-xl overflow-hidden">

            {/* HEADER */}

            <div className="bg-gradient-to-r from-[#1E1B4B] via-[#312E81] to-[#4F46E5] px-10 py-8 text-white">

              <div className="flex justify-between items-start">

                <div>

                  <p className="uppercase tracking-[6px] text-indigo-200 text-sm">

                    Premium Rental Quotation

                  </p>

                  <h1 className="text-5xl font-bold mt-3">

                    QUOTATION

                  </h1>

                  <p className="mt-4 text-indigo-100 text-sm">

                    Wedding • Catering • Event Rental

                  </p>

                </div>

                <div className="text-right">

                  <h2 className="text-3xl font-bold">

                    सुनंदा मंगल केंद्र

                  </h2>

                  <p className="mt-3 text-indigo-100 leading-7 text-sm">

                    २६३, शुक्रवार पेठ, मिरामाता चौक, चिंचेची तालीम जवळ, पुणे – ४११ ००२


                  </p>

                  <p className="mt-2 text-indigo-100 text-sm">

                    +91 9822336632

                  </p>

                </div>

              </div>

            </div>

            {/* CUSTOMER */}

            <div className="grid grid-cols-2 gap-6 p-10">

              <input
                type="text"
                placeholder="Customer Name"
                className="border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
                value={form.customer_name}
                onChange={(e) =>
                  setForm({

                    ...form,

                    customer_name:
                      e.target.value

                  })
                }
              />

              <input
                type="text"
                placeholder="Phone"
                className="border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
                value={form.phone}
                onChange={(e) =>
                  setForm({

                    ...form,

                    phone:
                      e.target.value

                  })
                }
              />

              <input
                type="text"
                placeholder="Address"
                className="border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500 col-span-2"
                value={form.address}
                onChange={(e) =>
                  setForm({

                    ...form,

                    address:
                      e.target.value

                  })
                }
              />

              <div className="col-span-2">

                <label className="text-sm font-medium text-gray-600 mb-2 block">

                  Rental Date

                </label>

                <input
                  type="date"
                  className="border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500 w-full"
                  onChange={(e) =>
                    setForm({

                      ...form,

                      rent_date:
                        e.target.value

                    })
                  }
                />

              </div>

            </div>

            {/* PRODUCTS */}

            <div className="px-10 pb-10">

              <div className="flex justify-between items-center mb-6">

                <div>

                  <h2 className="text-2xl font-bold text-gray-800">

                    Rental Products

                  </h2>

                  <p className="text-sm text-gray-500 mt-1">

                    Add products for quotation

                  </p>

                </div>

                <button
                  onClick={addProduct}
                  className="px-5 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-2xl font-semibold shadow-lg hover:scale-105 transition"
                >

                  + Add Product

                </button>

              </div>

              {/* TABLE */}

              <div className="overflow-hidden rounded-3xl border border-gray-100">

                <table className="w-full">

                  <thead className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white">

                    <tr>

                      <th className="p-4 text-sm font-semibold">

                        Product

                      </th>

                      <th className="p-4 text-sm font-semibold">

                        Qty

                      </th>

                      <th className="p-4 text-sm font-semibold">

                        Days

                      </th>

                      <th className="p-4 text-sm font-semibold">

                        Rent/Day

                      </th>

                      <th className="p-4 text-sm font-semibold">

                        Total

                      </th>

                    </tr>

                  </thead>

                  <tbody className="bg-white">

                    {form.products.map(
                      (item, index) => (

                        <tr
                          key={index}
                          className="border-b border-gray-100 hover:bg-gray-50 transition"
                        >

                          {/* PRODUCT */}

                          <td className="p-4">

                            <select
                              className="w-full border border-gray-200 bg-gray-50 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
                              value={item.product_id}
                              onChange={(e) =>
                                handleProductChange(

                                  index,
                                  "product_id",

                                  Number(
                                    e.target.value
                                  )

                                )
                              }
                            >

                              <option value="">
                                Select Product
                              </option>

                              {products.map(p => (

                                <option
                                  key={p.id}
                                  value={p.id}
                                >
                                  {p.name}
                                </option>

                              ))}

                            </select>

                          </td>

                          {/* QTY */}

                          <td className="p-4 text-center">

                            <input
                              type="number"
                              className="w-24 border border-gray-200 bg-gray-50 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
                              value={item.quantity}
                              onChange={(e) =>
                                handleProductChange(

                                  index,
                                  "quantity",

                                  Number(
                                    e.target.value
                                  )

                                )
                              }
                            />

                          </td>

                          {/* DAYS */}

                          <td className="p-4 text-center">

                            <input
                              type="number"
                              className="w-24 border border-gray-200 bg-gray-50 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-indigo-500"
                              value={item.days}
                              onChange={(e) =>
                                handleProductChange(

                                  index,
                                  "days",

                                  Number(
                                    e.target.value
                                  )

                                )
                              }
                            />

                          </td>

                          {/* RENT */}

                          <td className="p-4 text-center font-semibold text-gray-700">

                            ₹{item.rent}

                          </td>

{/* EXTRA CHARGES */}


                          {/* TOTAL */}

                          <td className="p-4 text-center font-bold text-indigo-700">

                            ₹{

                              item.rent *

                              item.quantity *

                              item.days

                            }

                          </td>

                        </tr>

                      )
                    )}

                  </tbody>

                </table>

              </div>
<div className="grid grid-cols-2 gap-6 mt-8">

  <div>

    <label className="block text-sm font-medium text-gray-600 mb-2">

      Labour Charges

    </label>

    <input
      type="number"
      value={form.labour_charge}
      onChange={(e) =>
        setForm({

          ...form,

          labour_charge:
            Number(e.target.value) || 0

        })
      }
      className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
    />

  </div>

  <div>

    <label className="block text-sm font-medium text-gray-600 mb-2">

      Transport Charges

    </label>

    <input
      type="number"
      value={form.transport_charge}
      onChange={(e) =>
        setForm({

          ...form,

          transport_charge:
            Number(e.target.value) || 0

        })
      }
      className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
    />

  </div>

</div>
              {/* TOTAL */}

              <div className="flex justify-end mt-8">

                <div className="w-80 bg-gradient-to-br from-[#1E1B4B] to-[#4F46E5] text-white rounded-3xl p-8 shadow-xl">

                  <p className="text-indigo-200 text-sm uppercase tracking-widest">

                    Grand Total

                  </p>

                  <div className="flex justify-between items-center mt-4">

                    <span className="text-lg">

                      Total Amount

                    </span>

                    <span className="text-4xl font-bold">

                      ₹{totalAmount}

                    </span>

                  </div>

                </div>

              </div>

              {/* PRINT BUTTON */}

              <div className="mt-10 flex justify-end">

                <button
                  onClick={printQuotation}
                  className="px-8 py-4 bg-gradient-to-r from-emerald-500 to-green-600 text-white rounded-2xl font-semibold shadow-lg hover:scale-105 transition"
                >

                  {id
  ? "Print Quotation"
  : "Save & Print Quotation"}

                </button>

              </div>

            </div>

          </div>

        </div>

        {/* =====================================
            PRINT VIEW
        ===================================== */}

        <div className="hidden print:block print-area bg-white min-h-screen p-8">

          <div className="max-w-3xl mx-auto border-[3px] border-indigo-900 p-6 text-indigo-950">

            {/* HEADER : logo (left) | business (center) | phone (right) */}

            <div className="flex items-center gap-4 border-b-2 border-indigo-900 pb-4">

              <img
                src={logo}
                alt="Logo"
                style={{ filter: "grayscale(100%)" }}
                className="w-20 h-20 object-contain shrink-0"
              />

              <div className="flex-1 text-center">

                <p className="text-sm">॥ श्री ॥</p>

                <h1 className="text-3xl font-bold tracking-wide">
                  सुनंदा मंगल केंद्र
                </h1>

                <p className="text-xs mt-1 leading-5">
                  २६३, शुक्रवार पेठ, मिरामाता चौक, चिंचेची तालीम जवळ, पुणे – ४११ ००२
                </p>

              </div>

              <div className="text-right text-xs shrink-0 w-24">
                <p>☎</p>
                <p>9822336632</p>
                <p>9762567691</p>
              </div>

            </div>

            {/* TITLE */}

            <div className="text-center py-2 border-b-2 border-indigo-900">
              <h2 className="text-2xl font-bold">
                कोटेशन / QUOTATION
              </h2>
            </div>

            {/* META : customer | date */}

            <div className="flex border-b-2 border-indigo-900">

              <div className="flex-1 border-r-2 border-indigo-900 p-3 text-sm">
                <p className="font-semibold">प्रती / To:</p>
                <p className="mt-1">{form.customer_name}</p>
                <p>{form.phone}</p>
                <p>{form.address}</p>
              </div>

              <div className="w-56 p-3 text-sm">
                <p>
                  <span className="font-semibold">दि. / Date:</span>{" "}
                  {form.rent_date
                    ? new Date(form.rent_date).toLocaleDateString("en-GB")
                    : ""}
                </p>
              </div>

            </div>

            {/* PRODUCTS TABLE */}

            <table className="w-full border-collapse text-sm">

              <thead>
                <tr className="bg-indigo-50">
                  <th className="border border-indigo-900 p-2 w-10">अ.क्र.</th>
                  <th className="border border-indigo-900 p-2 text-left">मालाचे वर्णन / Description</th>
                  <th className="border border-indigo-900 p-2 w-16">संख्या</th>
                  <th className="border border-indigo-900 p-2 w-16">दर</th>
                  <th className="border border-indigo-900 p-2 w-16">Days</th>
                  <th className="border border-indigo-900 p-2 w-24">एकूण</th>
                </tr>
              </thead>

              <tbody>

                {form.products.map((item, index) => {

                  const total =
                    Number(item.rent || 0) *
                    Number(item.quantity || 0) *
                    Number(item.days || 1);

                  return (
                    <tr key={index}>
                      <td className="border border-indigo-900 p-2 text-center">
                        {index + 1}
                      </td>
                      <td className="border border-indigo-900 p-2">
                        {item.name}
                      </td>
                      <td className="border border-indigo-900 p-2 text-center">
                        {item.quantity}
                      </td>
                      <td className="border border-indigo-900 p-2 text-center">
                        ₹{item.rent}
                      </td>
                      <td className="border border-indigo-900 p-2 text-center">
                        {item.days}
                      </td>
                      <td className="border border-indigo-900 p-2 text-right">
                        ₹{total}
                      </td>
                    </tr>
                  );
                })}

                <tr>
  <td
    colSpan="5"
    className="border border-indigo-900 p-2 text-right"
  >
    Rental Total
  </td>

  <td className="border border-indigo-900 p-2 text-right">
    ₹{rentalTotal}
  </td>
</tr>

<tr>
  <td
    colSpan="5"
    className="border border-indigo-900 p-2 text-right"
  >
    Labour Charges
  </td>

  <td className="border border-indigo-900 p-2 text-right">
    ₹{form.labour_charge}
  </td>
</tr>

<tr>
  <td
    colSpan="5"
    className="border border-indigo-900 p-2 text-right"
  >
    Transport Charges
  </td>

  <td className="border border-indigo-900 p-2 text-right">
    ₹{form.transport_charge}
  </td>
</tr>

<tr className="font-semibold bg-indigo-50">
  <td
    colSpan="5"
    className="border border-indigo-900 p-2 text-right"
  >
    Grand Total
  </td>

  <td className="border border-indigo-900 p-2 text-right">
    ₹{totalAmount}
  </td>
</tr>

              </tbody>

            </table>

            {/* FOOTER */}

            <div className="flex justify-between items-end mt-10 text-sm">
              <div>
                <p>रविवार बंद</p>
                <p className="mt-6">सही __________</p>
              </div>
              <div className="font-semibold">
                सुनंदा मंगल केंद्र करिता
              </div>
            </div>

          </div>

        </div>

      </div>

      {/* PRINT CSS */}

      <style>

        {`

        @media print {

          body * {

            visibility: hidden;

          }

          .print-area,
          .print-area * {

            visibility: visible;

          }

          .print-area {

            position: absolute;

            left: 0;
            top: 0;

            width: 100%;

            background: white;

          }

        }

        `}

      </style>

    </>

  );

};

export default Quotation;